import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AdminEditor from "@/pages/AdminEditor";
import RequireAdmin from "@/components/RequireAdmin";
import { BLOG_PATH } from "@/lib/blogConfig";

// Redirect helper for backward compatibility (/blog/:slug → /emerald-coast-real-estate-blog/:slug)
function BlogSlugRedirect() {
  const { slug } = useParams();
  return <Navigate to={`${BLOG_PATH}/${slug}`} replace />;
}

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator && window.location.protocol === "https:") {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .catch((err) => console.warn("SW registration failed", err));
      });
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path={BLOG_PATH} element={<Blog />} />
          <Route path={`${BLOG_PATH}/:slug`} element={<BlogPost />} />
          {/* Legacy URL aliases — keep older /blog links working forever */}
          <Route path="/blog" element={<Navigate to={BLOG_PATH} replace />} />
          <Route path="/blog/:slug" element={<BlogSlugRedirect />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/new"
            element={
              <RequireAdmin>
                <AdminEditor mode="new" />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/edit/:id"
            element={
              <RequireAdmin>
                <AdminEditor mode="edit" />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
